import React, { FC } from 'react'
import { ExternalLinkIcon } from 'uiKit/icons/ExternalLinkIcon'
import { KnowledgeBaseReply } from 'tabs/nlp/api/websiteKnowledgeBase' // Assuming this is where your type is defined
import { alertWarning } from 'api'
import {
  SourceItem,
  SourceList,
  SourceContainer,
  OpenInNewWindowAction,
  NoItems,
  ItemName, Divider, ExternalLinkWrap,
} from './KnowledgeBaseSources.style'
import Tooltip from '@material-ui/core/Tooltip'
import classes from './styles.module.scss'

interface Props {
  knowledgeBaseReply: KnowledgeBaseReply
  onOpenInNewWindowAction: (link: string, sourceType?: string, sourceName?: string) => void
}

const getFileExtension = (filename: string): string => {
  const match = filename.toLowerCase().match(/\.[a-z0-9]+$/)
  return match ? match[0] : ''
}

const getSourceDisplayName = (source: string, sourceName?: string | null): string => {
  if (!source) return sourceName || ''

  try {
    const pathFilename = decodeURIComponent(new URL(source).pathname.split('/').pop() || '')
    const pathExt = getFileExtension(pathFilename)
    const sourceExt = getFileExtension(sourceName || '')

    if (pathExt && sourceExt && pathExt !== sourceExt) {
      return pathFilename
    }
  } catch {
    // fall through to sourceName
  }

  return sourceName || source
}

const KnowledgeBaseSources: FC<Props> = ({ knowledgeBaseReply, onOpenInNewWindowAction }) => {
  const sources = knowledgeBaseReply.sources ? [...knowledgeBaseReply.sources] : []

  if (!sources.length && !knowledgeBaseReply.isFailed && !knowledgeBaseReply.isStoppedByUser) {
    sources.push({ sourceId: '', source: '', sourceName: '', sourceType: undefined })
  }

  return (
    <SourceContainer>
      <SourceList>
        {sources?.length ? (
          sources.map((source, index) => {
            const isGeneralKnowledge =
              (!source.source && !source.sourceName) &&
              !knowledgeBaseReply.isFailed &&
              !knowledgeBaseReply.isStoppedByUser
            const isLastItem = index === sources.length - 1
            const displayName = getSourceDisplayName(source.source, source.sourceName)

            return (
              <><Tooltip
                classes={{ tooltip: classes.tooltip }}
                title={isGeneralKnowledge
                  ? 'The response is based not on trained sources but on the custom prompt info and/or general ODIN knowledge'
                  : displayName}
                placement="top"
                key={index}
              >
                <SourceItem key={index}
                  onClick={() => {
                    if (isGeneralKnowledge) return
                    if (source.isDeleted) {
                      alertWarning('This source is no longer accessible')
                      return
                    }
                    onOpenInNewWindowAction(source.source, source.sourceType, source.sourceName)
                  }}
                >
                  <ItemName>
                    {isGeneralKnowledge ? 'General knowledge' : displayName}
                  </ItemName>

                  {/* Conditionally hide the "Open in New Window" button for GENERAL_KNOWLEDGE */}
                  {!isGeneralKnowledge && (
                    <ExternalLinkWrap>
                      <ExternalLinkIcon />
                    </ExternalLinkWrap>
                  )}
                </SourceItem>
              </Tooltip>
              {!isLastItem && (
                <Divider />
              )}
              </>
            )
          })
        ) : (
          <NoItems>No sources available</NoItems>
        )}
      </SourceList>
    </SourceContainer>
  )
}

export default KnowledgeBaseSources
